import { TIERS } from "@/data/slate";

const TierSection = ({ selectedTierId, onChange }) => (
    <section className="space-y-6">
        <h2 className="font-serif text-2xl font-medium tracking-tight">Tier</h2>
        <div className="grid gap-3 md:grid-cols-2">
            {TIERS.map((tier) => {
                const checked = selectedTierId === tier.id;
                return (
                    <label
                        key={tier.id}
                        data-testid={`tier-radio-${tier.id}`}
                        className={`cursor-pointer border p-5 transition-colors ${
                            checked
                                ? "border-primary bg-primary text-primary-foreground"
                                : "border-border bg-card hover:border-foreground"
                        }`}
                    >
                        <input
                            type="radio"
                            name="selected_tier"
                            value={tier.id}
                            checked={checked}
                            onChange={() => onChange("selected_tier", tier.id)}
                            className="sr-only"
                        />
                        <div className="flex items-baseline justify-between">
                            <p className="font-serif text-xl font-medium tracking-tight">
                                {tier.name}
                            </p>
                            <p className="font-serif text-xl">{tier.priceLabel}</p>
                        </div>
                        <p className={`mt-1 text-xs ${checked ? "text-primary-foreground/75" : "text-muted-foreground"}`}>
                            {tier.tagline}
                        </p>
                    </label>
                );
            })}
        </div>
    </section>
);

export default TierSection;
